import AskNicely from './AskNicely'
export default AskNicely
